import { render } from "./HomeView.vue?vue&type=template&id=864d967e&scoped=true"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"

import "./HomeView.vue?vue&type=style&index=0&id=864d967e&scoped=true&lang=scss"

import exportComponent from "E:\\liuniuWork\\example\\IPv6\\PC\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-864d967e"]])

export default __exports__